export const getProvider = (signerOrProvider) => {
    return signerOrProvider.provider;
};
export const convert41to0x = (address) => {
    return `0x${address.substring(2)}`;
};
export const convert0xto41 = (address) => {
    return `41${address.substring(2)}`;
};
export const resultToHexNumber = (result) => {
    return (result === null || result === void 0 ? void 0 : result._isBigNumber) ? result.toHexString() : "0x00";
};
